export default "__VITE_ASSET__965b9128__"